import _ from 'lodash'
import PROFESIONAL_FORMS_CONFIG from './config'

class ProfesionalFormsClass {
    constructor() {
        this.DOM = {
            section: PROFESIONAL_FORMS_CONFIG.section,
            togglers: PROFESIONAL_FORMS_CONFIG.togglers,
            forms: PROFESIONAL_FORMS_CONFIG.forms
        }

        this.DOM.section ? this.init() : null
    }

    init() {
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.togglers.forEach( ( toggler ) => { toggler.addEventListener( 'click', this._formToggle.bind( this )  ) })
    }

    _formToggle() {
        let toggle = event.currentTarget
        this.DOM.forms.forEach( ( form ) => {  
            _.containClass( form, `form__wrap--${toggle.value}`) ? _.addClass( form, 'is--active' ) : _.removeClass( form, 'is--active' )
        })
    }
}

const PROFESIONAL_FORMS = new ProfesionalFormsClass()
export default PROFESIONAL_FORMS